import { render, staticRenderFns } from "./CommunityCardCarousel.vue?vue&type=template&id=384fd131&"
import script from "./CommunityCardCarousel.vue?vue&type=script&lang=ts&"
export * from "./CommunityCardCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityCardCarousel.vue?vue&type=style&index=0&id=384fd131&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonDiagramCardNuxt: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonDiagramCardNuxt.vue').default,CommonContextMenu: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonContextMenu.vue').default})
